import { PATCH_PARAMS, POST_PARAMS, GET_PARAMS } from "./paramHelper";

export const CLIENT_CREATION_ERROR = "CLIENT_CREATION_ERROR";
export const RECEIVE_CLIENTS = "RECEIVE_CLIENTS";
export const RECEIVE_CLIENT = "RECEIVE_CLIENT";
export const CLIENT_UPDATE_ERROR = "CLIENT_UPDATE_ERROR";

export const fetchClients = token => async dispatch => {
  return await fetch("/api/clients", GET_PARAMS(token)).then(async response => {
    const { clients } = await response.json();

    return dispatch({
      type: RECEIVE_CLIENTS,
      clients
    });
  });
};

/**
 * Formats a string representation of a date to be in the format MM.DD.YY
 * @param id {int} Client id
 * @param serviceStop {string} Date string (todays date if stopping or null if restarting)
 */
export const updateClient = (id, body) => async dispatch => {
  // We shouldn't give the ability to update _any_ field for a client, thus this
  // action gives us the ability to start / stop a client by updating the service_stop
  // but isn't a traditional patch input that allows an update to any field
  try {
    const response = await fetch(
      `/api/clients/${id}`,
      PATCH_PARAMS({ client: body })
    );

    if (!response.ok) {
      const json = await response.json();
      throw new Error(json.error);
    }

    const { client } = await response.json();

    return dispatch({ type: RECEIVE_CLIENT, client });
  } catch (error) {
    return dispatch({ type: CLIENT_UPDATE_ERROR, error: error.message });
  }
};

/**
 * Formats a string representation of a date to be in the format MM.DD.YY
 * @param id {int} Client id
 * @param serviceStop {string} Date string (todays date if stopping or null if restarting)
 */
export const updateClientServiceStop = (id, serviceStop) => async dispatch => {
  // We shouldn't give the ability to update _any_ field for a client, thus this
  // action gives us the ability to start / stop a client by updating the service_stop
  // but isn't a traditional patch input that allows an update to any field
  try {
    const response = await fetch(
      `/api/clients/${id}`,
      PATCH_PARAMS({ client: { service_stop: serviceStop } })
    );

    if (!response.ok) {
      const json = await response.json();
      throw new Error(json.error);
    }

    const { client } = await response.json();

    return dispatch({ type: RECEIVE_CLIENT, client });
  } catch (error) {
    return dispatch({ type: CLIENT_UPDATE_ERROR, error: error.message });
  }
};

export const createClient = client => async dispatch => {
  try {
    const response = await fetch("/api/clients", POST_PARAMS({ client }));

    if (!response.ok) {
      const json = await response.json();
      throw new Error(json.error);
    }

    const json = await response.json();

    return dispatch({ type: RECEIVE_CLIENT, client: json.client });
  } catch (error) {
    return dispatch({ type: CLIENT_CREATION_ERROR, error: error.message });
  }
};
